/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Novideos2Inputs */

const id_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada video ditemukan`)
};

const ms_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada video ditemui`)
};

const da_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen videoer fundet`)
};

const de_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Videos gefunden`)
};

const en_us2_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No videos found`)
};

const es_es2_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron videos`)
};

const es_mx2_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron videos`)
};

const fil_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang video`)
};

const fr_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune vidéo trouvée`)
};

const it_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun video trovato`)
};

const hu_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található videó`)
};

const nl_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen video's gevonden`)
};

const no_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen videoer funnet`)
};

const pl_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono filmów`)
};

const pt_br2_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum vídeo encontrado`)
};

const pt_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum vídeo encontrado`)
};

const ro_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit videoclipuri`)
};

const fi_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoita ei löytynyt`)
};

const sv_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga videor hittades`)
};

const vi_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy video`)
};

const tr_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video bulunamadı`)
};

const cs_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyla nalezena žádná videa`)
};

const bg_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени видеа`)
};

const ru_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео не найдены`)
};

const uk_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відео не знайдено`)
};

const ar_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على فيديو`)
};

const hi_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई वीडियो नहीं मिला`)
};

const th_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบวิดีโอ`)
};

const ja_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画が見つかりません`)
};

const zh_cn2_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到视频`)
};

const zh_hant1_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到影片`)
};

const ko_offerdetail_media_novideos2 = /** @type {(inputs: Offerdetail_Media_Novideos2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동영상을 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No videos found" |
*
* @param {Offerdetail_Media_Novideos2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_novideos2 = /** @type {((inputs?: Offerdetail_Media_Novideos2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Novideos2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_novideos2(inputs)
	if (locale === "ms") return ms_offerdetail_media_novideos2(inputs)
	if (locale === "da") return da_offerdetail_media_novideos2(inputs)
	if (locale === "de") return de_offerdetail_media_novideos2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_novideos2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_novideos2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_novideos2(inputs)
	if (locale === "fil") return fil_offerdetail_media_novideos2(inputs)
	if (locale === "fr") return fr_offerdetail_media_novideos2(inputs)
	if (locale === "it") return it_offerdetail_media_novideos2(inputs)
	if (locale === "hu") return hu_offerdetail_media_novideos2(inputs)
	if (locale === "nl") return nl_offerdetail_media_novideos2(inputs)
	if (locale === "no") return no_offerdetail_media_novideos2(inputs)
	if (locale === "pl") return pl_offerdetail_media_novideos2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_novideos2(inputs)
	if (locale === "pt") return pt_offerdetail_media_novideos2(inputs)
	if (locale === "ro") return ro_offerdetail_media_novideos2(inputs)
	if (locale === "fi") return fi_offerdetail_media_novideos2(inputs)
	if (locale === "sv") return sv_offerdetail_media_novideos2(inputs)
	if (locale === "vi") return vi_offerdetail_media_novideos2(inputs)
	if (locale === "tr") return tr_offerdetail_media_novideos2(inputs)
	if (locale === "cs") return cs_offerdetail_media_novideos2(inputs)
	if (locale === "bg") return bg_offerdetail_media_novideos2(inputs)
	if (locale === "ru") return ru_offerdetail_media_novideos2(inputs)
	if (locale === "uk") return uk_offerdetail_media_novideos2(inputs)
	if (locale === "ar") return ar_offerdetail_media_novideos2(inputs)
	if (locale === "hi") return hi_offerdetail_media_novideos2(inputs)
	if (locale === "th") return th_offerdetail_media_novideos2(inputs)
	if (locale === "ja") return ja_offerdetail_media_novideos2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_novideos2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_novideos2(inputs)
	return ko_offerdetail_media_novideos2(inputs)
});
export { offerdetail_media_novideos2 as "offerDetail.media.noVideos" }